import * as z from "zod/v4";

export const deleteAeoPromptTopic = {
  name: "deleteAeoPromptTopic" as const,
  input: z.object({ topicId: z.bigint() }),
  output: z.object({ deleted: z.boolean() }),
};
